import { getProductRangeDetail } from "../../../../lib/admin";
import { ProductRange } from "../../../../types";
import StoreReportDetails, { DetailBox, DetailFields, formatDetailDate } from "../shared/StoreReportDetails";
import { useReportDetail } from "../hooks/useReportDetail";

type Props =
    {
        storeId: number
        productRange: ProductRange
    }

export default function StoreReportRangeDetails({ storeId, productRange }: Props) {
    const { detail, isLoading, error } = useReportDetail(
        () => getProductRangeDetail(storeId, productRange.id),
        `${storeId}:${productRange.id}`,
        "Could not load the details of this product range.",
    );

    return (
        <StoreReportDetails mirrorError={productRange.error} isLoading={isLoading} error={error}>
            {(showRaw) => detail && (
                <div className="product-details-grid">
                    <DetailBox title="In Shopify" source={detail.shopify} found={detail.shopify.found} error={detail.shopify.error} showRaw={showRaw}>
                        <DetailFields entries={[
                            ["Title", detail.shopify.title ?? ""],
                            ["Handle", detail.shopify.handle ?? ""],
                            ["Updated", formatDetailDate(detail.shopify.updatedAt)],
                            ["Published", formatDetailDate(detail.shopify.publishedAt)],
                        ]} />
                    </DetailBox>
                    <DetailBox title="On index" source={detail.index} found={detail.index.found} error={detail.index.error} showRaw={showRaw}>
                        <DetailFields entries={[["Indexed products", `${detail.index.products ?? 0}`]]} />
                    </DetailBox>
                </div>
            )}
        </StoreReportDetails>
    );
}
